(function () {

  function realSlides(slider) {
    return Array.prototype.filter.call(slider.children, function (el) {
      return el.classList.contains('product__media-item') && !el.classList.contains('hm-gallery-loop-clone');
    });
  }

  function allSlides(slider) {
    return Array.prototype.filter.call(slider.children, function (el) {
      return el.classList.contains('product__media-item');
    });
  }

  function wipeIds(node) {
    if (node.id) node.id = 'HmLoop-' + node.id;
    node.querySelectorAll('[id]').forEach(function (el) {
      el.id = 'HmLoop-' + el.id;
    });
  }

  function nearestSlide(slider) {
    var nodes = allSlides(slider);
    var left = slider.scrollLeft;
    var best = null;
    var dist = Infinity;
    for (var i = 0; i < nodes.length; i++) {
      var d = Math.abs(nodes[i].offsetLeft - left);
      if (d < dist) {
        dist = d;
        best = nodes[i];
      }
    }
    return best;
  }

  function syncThumbs(gallery, slide) {
    if (!slide || !gallery.elements || !gallery.elements.thumbnails) return;
    var thumb = gallery.elements.thumbnails.querySelector('[data-target="' + slide.dataset.mediaId + '"]');
    if (!thumb || typeof gallery.setActiveThumbnail !== 'function') return;
    gallery.setActiveThumbnail(thumb);
    var scroller = gallery.elements.thumbnails.slider || gallery.elements.thumbnails.querySelector('[id^="Slider-"]');
    if (!scroller) return;
    var max = scroller.scrollWidth - scroller.clientWidth;
    if (max <= 0) return;
    var left = thumb.offsetLeft - (scroller.clientWidth - thumb.clientWidth) / 2;
    scroller.scrollTo({ left: Math.max(0, Math.min(max, left)) });
  }

  function arm(gallery) {
    var viewer = gallery.elements && gallery.elements.viewer;
    var slider = viewer && (viewer.slider || gallery.querySelector('[id^="Slider-Gallery"]'));
    if (!slider || slider.dataset.hmLoopReady === '1') return;
    var slides = realSlides(slider);
    if (slides.length < 2) return;
    slider.dataset.hmLoopReady = '1';

    var first = slides[0];
    var last = slides[slides.length - 1];
    var cloneFirst = first.cloneNode(true);
    var cloneLast = last.cloneNode(true);
    cloneFirst.classList.add('hm-gallery-loop-clone');
    cloneLast.classList.add('hm-gallery-loop-clone');
    cloneFirst.dataset.hmLoop = 'first';
    cloneLast.dataset.hmLoop = 'last';
    wipeIds(cloneFirst);
    wipeIds(cloneLast);
    slider.insertBefore(cloneLast, first);
    slider.appendChild(cloneFirst);
    if (viewer && typeof viewer.resetPages === 'function') viewer.resetPages();

    var jumping = false;
    var jumpTimer;
    function realFor(slide) {
      if (!slide) return null;
      if (slide.dataset.hmLoop === 'first') return first;
      if (slide.dataset.hmLoop === 'last') return last;
      return slide;
    }

    function mark(slide) {
      var real = realFor(slide);
      if (!real) return;
      realSlides(slider).forEach(function (item) {
        item.classList.toggle('is-active', item === real);
      });
      syncThumbs(gallery, real);
    }

    function snapTo(el) {
      if (!el) return;
      jumping = true;
      clearTimeout(jumpTimer);
      var prev = slider.style.scrollSnapType;
      slider.style.scrollSnapType = 'none';
      slider.scrollLeft = el.offsetLeft;
      mark(el);
      requestAnimationFrame(function () {
        slider.scrollLeft = el.offsetLeft;
        slider.style.scrollSnapType = prev;
        jumpTimer = setTimeout(function () {
          jumping = false;
        }, 180);
      });
    }

    var thumbs = gallery.elements.thumbnails;
    if (thumbs) {
      thumbs.querySelectorAll('[data-target]').forEach(function (item) {
        var btn = item.querySelector('button');
        if (!btn) return;
        btn.addEventListener(
          'click',
          function (event) {
            var slide = realSlides(slider).find(function (el) {
              return el.dataset.mediaId === item.dataset.target;
            });
            if (!slide) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            snapTo(slide);
            if (typeof gallery.playActiveMedia === 'function') gallery.playActiveMedia(slide);
          },
          true
        );
      });
    }

    function settle() {
      if (jumping) return;
      var slide = nearestSlide(slider);
      if (!slide) return;
      if (slide.dataset.hmLoop === 'first') snapTo(first);
      else if (slide.dataset.hmLoop === 'last') snapTo(last);
      else mark(slide);
    }

    var ticking = false;
    slider.addEventListener(
      'scroll',
      function () {
        if (jumping) return;
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            mark(nearestSlide(slider));
          });
        }
        clearTimeout(slider._hmLoopTimer);
        slider._hmLoopTimer = setTimeout(settle, 80);
      },
      { passive: true }
    );
    slider.addEventListener('scrollend', settle);

    requestAnimationFrame(function () {
      snapTo(first);
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (typeof gallery.setActiveThumbnail !== 'function') return;
      arm(gallery);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
